import { useState, useEffect, useCallback } from "react";
import { getTitleURL } from "../../utils/ConstantsURL";

export function useTitleStyles(token, idDocument) {
  const [stylesTitle, setStylesTitle] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);

  const refresh = useCallback(() => {
    setRefreshIndex((prev) => prev + 1);
  }, []);

  useEffect(() => {
    if (!token || !idDocument) return;

    const fetchTitleStyles = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(getTitleURL(idDocument), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Error desconocido");
        setStylesTitle(data);
      } catch (err) {
        console.error("useTitleStyles:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTitleStyles();
  }, [token, idDocument, refreshIndex]);

  return { stylesTitle, loading, error, refresh };
}
